/**
 * @fileoverview Component Price
 * @version 1.0
 * @author Carlos Emilio Blanco Lopez
 * @date 14/02/2023
 * @copyright 2023 Industrias RESSER S.A de C.V
 */

import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from '../../hooks/storeHooks';
import styles from "./CreditFormstyle";
import { Grid, TextField, MenuItem, Select, InputLabel, FormControl} from '@mui/material';
import {
    InputPrice,
    InputSelect, 
} from '../Inputs/Inputs'
import {setCreditResultadoCotizacion} from '../../reducer/slices/DataResponse';
import { getPayment, getCredit, getPlazo, getProductTypeOption, getTasa } from "../../reducer/slices/DataCotizador";

const useStyles = styles;
const listproduct = [
    { id: 0, name: "Crédito Simple" },
    { id: 1, name: "Crédito Revolvente" },
];

/**
 * @title ComponentPrice
 * @returns Fragment
 */

const ComponentPrice = () => {
    const classes = useStyles();
    const { width } = useAppSelector(state => state.dimensions);
    const dataCotizacion = useAppSelector(state => state.DataCotizador);
    const { CreditResultCotizacion} = useAppSelector(state => state.DataResponse);
    const { CreditObjPlazo} = useAppSelector(state => state.DataResponse);
    const [termOptions, setTermOptions] = useState<number[]>([]);

    const dispatch = useAppDispatch();
    const onChangeCredit = (value:number) => {
        dispatch(getCredit(value));
    }

    const resetFields = () => {
        dispatch(getCredit(0))
        dispatch(getPlazo(0))
        dispatch(getTasa(0))
        dispatch(setCreditResultadoCotizacion([]))
      };
    const onChangeProduct = (value: number) => {
        dispatch(getProductTypeOption(value));
        resetFields();
    }
    const onChangePlazo = (value: number) => {
        dispatch(getPlazo(value))
        const index = CreditObjPlazo[0]?.details.terms.findIndex((term) => term === value);
        const tasa = Number(CreditObjPlazo[0]?.details.rates[index]);
        dispatch(getTasa(tasa));
    }

        useEffect(() => {
            dispatch(getProductTypeOption());
            resetFields();
            dispatch(setCreditResultadoCotizacion([]))

        }, [dataCotizacion.quoteType]);

    
    useEffect(() => {
        CreditResultCotizacion?.map((result) => {
          if (Array.isArray(result.terms) && result.terms.length > 0) {
            const term = result.terms[dataCotizacion.productTypeOption === 0 ? 0 : result.terms.length - 1];
            dispatch(getPayment(term.payment));

          }
        });
      }, [CreditResultCotizacion, dataCotizacion.productTypeOption]);

      useEffect(() => {
        const availablePlazos = CreditObjPlazo[0]?.details.terms || [];

        if (dataCotizacion.productTypeOption === 1) {
            setTermOptions([12]);
        } else {
            setTermOptions(availablePlazos);
        }
    }, [dataCotizacion.productTypeOption, CreditObjPlazo]);

    return (
        <div className={width>700?classes.Container: classes.MobilContent}>
            <div className={classes.Content}>
                <h3 className={classes.txtTitleQuote}>Selecciona el tipo de financiamiento</h3>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <InputSelect
                            label="Tipo de financiamiento"
                            setValue={onChangeProduct}
                            value={dataCotizacion.productTypeOption}
                            disabled = {dataCotizacion.isDisableQuoteForm}
                            listItems={listproduct} 
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <h3 className={classes.txtTitleQuote}>Calcula tus pagos</h3>
                        <InputPrice
                            disabled={dataCotizacion.isDisableQuoteForm}
                            label='Monto de financiamiento'
                            onChange = {onChangeCredit}
                            value={dataCotizacion.credit}
                            isPrice
                            isNumber
                        />
                    </Grid>
                    <Grid item xs={12} md={12} style={{ marginBottom: 20 }}>
                        <InputSelect
                            label="Plazos solicitados"
                            setValue={onChangePlazo}
                            value={termOptions.includes(dataCotizacion.plazo) ? dataCotizacion.plazo : termOptions[0]}
                            disabled={dataCotizacion.isDisableQuoteForm}
                            listItems={termOptions.map((term) => ({ id: term, name: term.toString() }))}
                        />
                    </Grid>
                </Grid>

            </div>
        </div>
    );
}

export default ComponentPrice;